import React, { Component } from "react";
import VCF from "vcf";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MailIcon from "@mui/icons-material/Mail";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import NotesIcon from "@mui/icons-material/Notes";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";

class VCardDialog extends Component {
  header = store.getState().header.header;

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      contact: {},
    };
  }

  /** Opens dialog with existing row data or fetches from server */
  showVCardDetails(rowData, messageId) {
    if (rowData !== null) {
      this.setState({
        open: true,
        contact: rowData,
      });
    } else {
      this.getVCardDetails(messageId);
    }
  }

  /** Fetch vCard from backend and parse */
  getVCardDetails(messageId) {
    const postObject = {
      header: this.header,
      smsMessage: { id: messageId },
    };

    FetchServerData.callPostService("/smsmessagems/getVcardData", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          const vCardBase64 = output.data;
          if (!vCardBase64) return;

          let text = this.base64ToString(vCardBase64);
          if (!text.startsWith("BEGIN:VCARD")) {
            const index = text.indexOf("BEGIN:VCARD");
            if (index >= 0) text = text.slice(index);
          }
          text = text.replace(/\r?\n/g, "\r\n").trim();

          const vcard = new VCF().parse(text);

          let phones = vcard.get("tel") || [];
          if (!Array.isArray(phones)) phones = [phones];
          let emails = vcard.get("email") || [];
          if (!Array.isArray(emails)) emails = [emails];
          let urls = vcard.get("url") || [];
          if (!Array.isArray(urls)) urls = [urls];
          let adr = vcard.get("adr") || [];
          if (!Array.isArray(adr)) adr = [adr];

          const addresses = adr.map((a) => {
            let parts = a.valueOf();
            if (typeof parts === "string") parts = parts.split(";");
            return {
              street: parts[2] || "",
              city: parts[3] || "",
              state: parts[4] || "",
              postalCode: parts[5] || "",
              country: parts[6] || "",
            };
          });

          let photoUrl = null;
          let photoObj = vcard.get("photo");

          if (photoObj) {

            if (Array.isArray(photoObj)) {
              photoObj = photoObj[0];
            }

            const value = photoObj.valueOf();

            // Case 1: Already full data URL
            if (typeof value === "string" && value.startsWith("data:image")) {
              photoUrl = value;
            }

            // Case 2: Raw base64 string
            else if (typeof value === "string") {
              photoUrl = `data:image/jpeg;base64,${value}`;
            }

            // Case 3: Structured object
            else if (value?.Property?._data) {
              const type = value.Property.mediatype || "image/jpeg";
              photoUrl = `data:${type};base64,${value.Property._data}`;
            }
          }
          const data = {
            name: vcard.get("fn")?.valueOf() || "",
            nickname: vcard.get("nickname")?.valueOf() || "",
            org: vcard.get("org")?.valueOf() || "",
            title: vcard.get("title")?.valueOf() || "",
            phones: phones.map((p) => p.valueOf()),
            emails: emails.map((e) => e.valueOf()),
            urls: urls.map((u) => u.valueOf()),
            note: vcard.get("note")?.valueOf() || "",
            photo: photoUrl || null,
            addresses,
          };

          this.setState({ contact: data, open: true });
        }
      })
      .catch((err) => console.error(err));
  }

  base64ToString(base64) {
    try {
      return decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
    } catch {
      return "";
    }
  }

  handleClose() {
    this.setState({ open: false });
  }

  getInitials(name) {
    if (!name) return "?";
    const parts = name.split(" ");
    return (
      (parts[0][0] || "").toUpperCase() +
      (parts.length > 1 ? parts[parts.length - 1][0].toUpperCase() : "")
    );
  }

  render() {
    const { open, contact } = this.state;
    return (
      <Dialog
        open={open}
        onClose={this.handleClose.bind(this)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "20px",
            overflow: "hidden",
            background: "#f9f9fb",
            width: "450px",
            maxWidth: "90%",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          className="text-white text-start"
          style={{
            background: "#337ab7",
            fontWeight: "600",
            fontSize: "1.1rem",
            position: "relative",
          }}
        >
          vCard Details
          <IconButton
            onClick={this.handleClose.bind(this)}
            style={{ position: "absolute", right: 8, top: 8, color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Body */}
        <DialogContent
          style={{
            background: "#f2f5f9 ",
          }}
        >
          <div className="p-3">
            <div className="row pt-3">
              {/* Profile Section */}
              <div className="col-md-3 text-center mb-3 mb-md-0">
                <div
                  className="d-flex align-items-center justify-content-center text-white mx-auto mb-2"
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: contact.photo ? "0%" : "50%",
                    background: contact.photo
                      ? "none"
                      : "linear-gradient(135deg, #1976d2, #64b5f6)",
                    fontSize: "2rem",
                    fontWeight: "600",
                    overflow: "hidden", // ensures circular crop for image
                  }}
                >
                  {contact.photo ? (
                    <img
                      src={contact.photo}
                      alt={contact.org || "Profile"}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    this.getInitials(contact.org)
                  )}
                </div>
              </div>

              {/* Info Section */}
              <div className="col-md-9">
                {(contact.name || contact.org) && (
                  <div className="d-flex align-items-start mb-2">
                    <BusinessIcon
                      className="text-primary me-2 mt-1"
                      fontSize="small"
                    />
                    <div>
                      {(this.state.contact?.name ||
                        this.state.contact?.org) && (
                          <div
                            style={{
                              fontSize: "0.9rem",
                              wordBreak: "break-word",
                            }}
                          >
                            <h6 className="fw-bold mb-0">
                              {this.state.contact?.org
                                ? `${this.state.contact?.org}`
                                : ""}
                            </h6>
                            <small className="">
                              {this.state.contact?.title || ""}{" "}
                              {this.state.contact?.name
                                ? `${this.state.contact?.name}`
                                : ""}
                            </small>
                          </div>
                        )}
                    </div>
                  </div>
                )}

                {contact.phones?.length > 0 && (
                  <div className="d-flex align-items-start mb-2">
                    <PhoneIcon
                      className="text-primary me-2 mt-1"
                      fontSize="small"
                    />
                    <div>
                      {contact.phones.map((p, i) => (
                        <div
                          key={i}
                          style={{
                            fontSize: "0.9rem",
                            wordBreak: "break-word",
                          }}
                        >
                          {typeof p === "object" ? p.value : p}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {contact.emails?.length > 0 && (
                  <div className="d-flex align-items-start mb-2">
                    <MailIcon
                      className="text-primary me-2 mt-1"
                      fontSize="small"
                    />
                    <div>
                      {contact.emails.map((e, i) => (
                        <div
                          key={i}
                          style={{
                            fontSize: "0.9rem",
                            wordBreak: "break-word",
                          }}
                        >
                          {typeof e === "object" ? e.value : e}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {contact.urls?.length > 0 && (
                  <div className="d-flex align-items-start mb-2">
                    <LanguageIcon
                      className="text-primary me-2"
                      fontSize="small"
                    />
                    <div
                      style={{ wordBreak: "break-word", whiteSpace: "normal" }}
                    >
                      {contact.urls.map((u, i) => (
                        <a
                          key={i}
                          href={u.value || u}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            display: "block", // makes each URL appear on a new line
                            textDecoration: "none",
                            color: "#1976d2",
                            fontSize: "0.9rem",
                            wordBreak: "break-all", // ensures long URLs break properly
                          }}
                        >
                          {u.value || u}
                        </a>
                      ))}
                    </div>
                  </div>
                )}

                {contact.addresses?.length > 0 &&
                  contact.addresses.some(a => a.country && a.country.trim() !== "") && (
                    <div className="d-flex align-items-start mb-2">
                      <HomeIcon
                        className="text-primary me-2 mt-1"
                        fontSize="small"
                      />
                      <div
                        style={{
                          fontSize: "0.9rem",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {contact.addresses.map((a, i) => {
                          const fullAddress = [
                            a.street,
                            a.city,
                            a.state,
                            a.country,
                          ]
                            .filter(Boolean) // removes empty parts
                            .join(", "); // combine with commas
                          return (
                            <div key={i} style={{ marginBottom: "4px" }}>
                              {fullAddress}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                {contact.note && (
                  <div className="d-flex align-items-start">
                    <NotesIcon
                      className="text-primary me-2 mt-1"
                      fontSize="small"
                    />
                    <div style={{ fontSize: "0.9rem" }}>{contact.note}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default VCardDialog;
